module.exports = __webpack_public_path__ + "media/application/images/icons/innovations/level-green-high-bf6a74d369ec160546ac4dc0a9d32846.svg";